const TKINTSEARCHINFO = () => {
  return {
    queryStr: {
      'departAirport': '',
      'arriveAirport': '',
      'travelType': '',//是否往返程 2往返程 空或1单程 ,
      'returnDate': '',//返程日期日期不能为空 ,
      'corpId': '',
      'cabinType': '',
      'tripType': '',
      'showStop': '',//是否经停 1显示0不显示 ,
      'infNum': 0,//婴儿数量 ,
      'chdNum': 0,// 儿童数量 ,
      'aduNum': 0,//成人数量 ,
      'airline': '',//航司二字代码 ,
      'requestId': '',//请求标记，第二次请求时回传，为第一次请求返回的值，避免重复查询数据库 ,
      'startCount': 0,//开始条数 ,
      'count': 20,//显示多少条数据
    },
    arriveDate: {},
    departDate: {},
    flights: [],
    showMinPriceTips: false,//航班查询时，以弹窗形式提示 全天最低价
    path: '/tk/tkIntEdit',
    backPath: '/tk/tkQuery',
    minDate: '',
    maxDate:''
  }
}
const tkInt ={
  namespaced: true, 

  state:{//state就是Vuex中的公共的状态, 我是将state看作是所有组件的data, 用于保存所有组件的公共数据.
    tkIntSearchInfo: TKINTSEARCHINFO(),
    travelerList: [],
    pageCtrl: {},
    Refunditem:'', //选择退票时传的item
  },
  getters:{//getters属性理解为所有组件的computed属性, 也就是计算属性 
    tkIntSearchInfo: (state) => state.tkIntSearchInfo || {},
    travelerList: (state) =>  state.travelerList || [],
    // pageCtrl: (state) => state.pageCtrl || {},
    Refunditem: (state) => state.Refunditem || {}
  },
  mutations:{ //mutaions理解为store中的methods
    tkIntSearchInfo(state, payload ) {
      Object.assign(state.tkIntSearchInfo , payload)
    },
    travelerList (state, payload ) {
      state.travelerList=payload
    },
    pageCtrl (state, payload ) {
      state.pageCtrl=payload
    },
    SET_VIOLATELIST(state, payload){
      state.tkIntSearchInfo.violate=payload
    },
    CLEAR_ALL (state, payload) { 
      state.tkIntSearchInfo=TKINTSEARCHINFO()
      state.travelerList=[]
    },
    Refunditem(state, payload){
      // consoel.log("15356362")
      state.Refunditem=payload
    }
  },
  actions:{ //添加actions actions中可以包含异步操作
    //10914 航班查询时，以弹窗形式提示 全天最低价
    async getParams ({ commit, state }) {
      try {
        let res = await api['common/queryParameter']({
          paramNos:'10914'
        })
        let cache = res.data || {}
        let params = cache.parameterResponses || []
        params.forEach(item => {
          if (item.paramNo == 10914) { 
            state.tkIntSearchInfo.showMinPriceTips = item.value1 == 1 ? true : false
          }
        })
      } catch (err) {
        console.error(err)
      }
    }
  }
}
export default tkInt